import { Box, Flex, Button } from "@chakra-ui/react";
import { MdArrowBackIos } from "react-icons/md";
import { Text } from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";

type ObservationSubHeaderProps = {
  title: string;
  backLink: string | number;
};

function ObservationSubHeader({ title, backLink }: ObservationSubHeaderProps) {
  const navigate = useNavigate();

  return (
    <Box
      gridColumn="1 / -1"
      gridRow="1"
      hideBelow="sm"
      py="2"
      bg="white"
      borderColor="border"
      borderBottomWidth="1px"
    >
      <Flex
        gap="2"
        alignItems="center"
        px="4"
        maxW={{ md: "7xl", "2xl": "8xl" }}
        mx="auto"
      >
        {typeof backLink === "string" ? (
          <Link
            to={backLink}
            aria-label="Back to previous page"
          >
            <MdArrowBackIos />
          </Link>
        ) : (
          <Button
            color={{ base: "white", sm: "gray.700" }}
            bgColor={{base: "transparent", sm: "bg"}}
            onClick={() => navigate(-1)}
            aria-label="Back to previous page"
          >
            <MdArrowBackIos />
          </Button>
        )}
        <Text fontSize="xs" mx="auto">
          { title }
        </Text>
      </Flex>
    </Box>
  );
}

export default ObservationSubHeader;
